exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CustomActivity_box .search_criteria[data-v-5fc76a8d]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.CustomActivity_box .search_criteria>div[data-v-5fc76a8d]{margin:6px 5px;width:180px;border:1px solid #efefef}.page_box[data-v-5fc76a8d]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.page_box[data-v-5fc76a8d]  .el-pagination__jump{margin-left:0px}", ""]);

// exports
